import { axiosInstance, CancelToken } from 'boot/axios';
import Notify from 'src/constants/notify';
import i18n from 'src/i18n/index.js';

export function startDownload({ commit }, payload) {
  const cancel = [];

  const endpoint = payload.endpoint;
  const queryParams = payload.queryParams;

  commit('setIsLoading', {
    type: 'DOWNLOAD',
    value: true,
  });

  return axiosInstance
    .get(endpoint, {
      params: queryParams,
      responseType: 'arraybuffer',

      cancelToken: new CancelToken(function executor(c) {
        cancel.push(c);
      }),
    })
    .then((response) => {
      if (response.status === 204) {
        Notify.create(
          {
            type: 'negative',
            position: 'bottom-right',
            message: i18n.global.t('documents.download.failed', {
              error: 204,
            }),
          },
          response,
        );
      } else {
        return new Uint8Array(response.data);
      }
    })
    .catch((error) => {
      let message;

      if (error.response) {
        /*
         * The request was made and the server responded with a
         * status code that falls out of the range of 2xx
         */
        message = i18n.global.t('documents.download.failed', {
          error: error.response.status,
        });
      } else if (error.request) {
        /*
         * The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest in the browser
         */
        message = i18n.global.t('documents.download.failed', {
          error: 'Request failed',
        });
      } else {
        // Something happened in setting up the request and triggered an Error
        message = i18n.global.t('documents.download.failed', {
          error: error.download,
        });
      }

      Notify.create(
        {
          type: 'negative',
          message: message,
          position: 'bottom-right',
        },
        error.response,
      );
      throw error;
    })
    .finally(() => {
      commit('setIsLoading', {
        type: 'DOWNLOAD',
        value: false,
      });
    });
}
